import hasButton from './hasButton'
const install = function (Vue) {
  Vue.directive('hasPermit', hasButton)
}

if (window.Vue) {
  window['hasButton'] = hasButton
  Vue.use(install) // eslint-disable-line
}
export default install
